import {
  TextField,
  InputAdornment,
  useMediaQuery,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";

interface SearchFieldProps {
  search: string;
  setSearch: (value: string) => void;
  placesCount: number;
}

const SearchField: React.FC<SearchFieldProps> = ({
  search,
  setSearch,
  placesCount,
}) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const normalPlaceholder: string = t("pages.historyReading.searchPlaceholder")
    .replace(
      "{places}",
      placesCount === 1
        ? "místo"
        : placesCount >= 2 && placesCount <= 4
        ? "místa"
        : "míst"
    )
    .replace("{count}", placesCount.toString());

  return (
    <TextField
      label={t("pages.historyReading.search")}
      variant="outlined"
      fullWidth={!isSmallScreen}
      placeholder={
        !isSmallScreen
          ? normalPlaceholder
          : t("pages.historyReading.searchPlaceholderMobile")
      }
      sx={{ maxWidth: 500, mb: 3, mt: 3 }}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      slots={{ input: OutlinedInput }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchField;
